import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { ICulture } from '../../models/session.interface';
import { MeService } from '../../services/me.service';

@Component({
  selector: 'ui-btn-cultures',
  templateUrl: './ui-btn-cultures.component.html',
  styleUrls: ['./ui-btn-cultures.component.css'],
  imports: [MatButton, MatMenuTrigger, MatMenu, MatMenuItem]
})
export class UiBtnCulturesComponent {

  constructor(private me: MeService) { }

  public get cultures(): ICulture[] {

    return this.me.session.cultures;

  }

  public get locale(): string {

    return this.me.session.locale;

  }

  public async setLocale(locale: string) {

    // reload session for new locale
    this.me.session.locale = locale;
    await this.me.initSession(this.me.session.domainId);

    // reload page
    await this.me.reload();

  }

}
